import { StateCreator } from "zustand";

export interface ImageViewerOptions {
    description: string;
    name: string;
    lastModified: string;
    size: string;
    creator: string;
    readonly: boolean;
}

export interface ImageViewerState {
    base64: string | null;
    options?: ImageViewerOptions;
    onClose: (description?: string) => void;
}

export interface ImageViewerSlice {
    imageViewer: ImageViewerState;
    setImageViewer: (state: ImageViewerState) => void;
    resetImageViewer: () => void;
}

const initialImageViewerState: ImageViewerState = {
    base64: null,
    options: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: () => {},
};

export const createImageViewerSlice: StateCreator<ImageViewerSlice, [], [], ImageViewerSlice> = (set) => ({
    imageViewer: initialImageViewerState,

    setImageViewer: (state) => set({ imageViewer: state }),
    resetImageViewer: () => set({ imageViewer: initialImageViewerState }),
});

